// tslint:disable:max-line-length
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import {
    Compiler,
    ComponentRef,
    Injector,
    NgModuleRef,
    ReflectiveInjector,
    ResolvedReflectiveProvider,
    SystemJsNgModuleLoader
} from "@angular/core";
import { TCITenantRemoteServices } from "./ng-tenant/tci-tenant-remote-services";
import { ITCITenantComponentOptions, TCITenantAppType, QUERY_PARAMS, BASE_CONSTANTS, TCITenantAppDetailsMenu } from "@tci/common";
import { TciTenantService } from "./ng-tenant/tci-tenant.service";
import { ITCITenantComponentInput } from "../../../common/src/model/tci/tci-component";
import { TciTenantComponentCacheService, ITCIResFactory } from "./ng-tenant/tci-tenant-component-cache.service";
import { AbstractTCITenantComponent } from "./ng-tenant/tci-tenant-component";
import { TCITenantMenuServices } from "./ng-tenant/tci-tenant.menu";
import { NgAuthGuardService } from "./ng-shared/ng-services/ng-auth-guard.service";
import { ITCITenantNotAvailableParams } from "./ng-tenants-not-available/ng-tenants-not-available.component";

import * as lodash from "lodash";

// The following two types are used at others route activators
export type TCIRouteSelectorResolver = (routeId: string) => ITCITenantComponentOptions<any>;
export type TCIRouteInputResolver<I extends ITCITenantComponentInput> = (inputId: string, appType: string, compOptions: ITCITenantComponentOptions<any>) => Observable<I>;

interface ICacheResponse {
    tenantType: TCITenantAppType;
    resFactory: ITCIResFactory<any, any>;
}

export class TciTenantAppsRouteActivator<I extends ITCITenantComponentInput> implements CanActivate {
    private resolvedProviders: ResolvedReflectiveProvider[];
    private componentInjector: ReflectiveInjector;
    private cmpRef: ComponentRef<any>;
    private initialized = false;
    private initialized$: Subject<boolean> = new Subject();

    constructor(
        private parentInjector: Injector,
        private loader: SystemJsNgModuleLoader,
        private compiler: Compiler,
        private tenantRemoteServices: TCITenantRemoteServices,
        private tenantSvc: TciTenantService,
        private tenantCacheService: TciTenantComponentCacheService,
        private tenantMenuSrv: TCITenantMenuServices,
        private authSvc: NgAuthGuardService,
        private router: Router,
        private routeResolver?: TCIRouteSelectorResolver,
        private inputResolver?: TCIRouteInputResolver<I>,
        private checkForParams?: boolean
    ) {
        // if (lodash.isUndefined(checkForParams)) { // Default value
        //     this.checkForParams = true;
        // }

        // this.initialized$.subscribe(val => this.initialized = val);
        // this.init()
        //     .subscribe(res => {
        //         console.log("The tenants (from tci-tenant-route-activator):", res);
        //     }, err => {
        //         console.error(err);
        //     }, () => {
        //     });
    }

    // private init(): Observable<any> {
    //     // this.tenantCacheService.onInit()
    //     this.tenantSvc.onInit()
    //         .subscribe(
    //             res => {
    //                 this.resolvedProviders = ReflectiveInjector.resolve([
    //                     {
    //                         provide: Injector,
    //                         useValue: this.parentInjector
    //                     }
    //                 ]);
    //                 this.componentInjector = ReflectiveInjector.fromResolvedProviders(
    //                     this.resolvedProviders,
    //                     this.parentInjector
    //                 );
    //                 this.initialized$.next(true);
    //             },
    //             err => {
    //                 console.warn("Error loading dynamic component:", err.message);
    //             }
    //         );
    //     return this.onInit();
    // }

    // public isInit() {
    //     return this.initialized;
    // }

    public onInit(): Observable<boolean> {
        // if (!this.initialized) {
        //     return this.initialized$;
        // } else {
        return Observable.of(true);
        // }
    }

    private getInjector(): Injector {
        return this.componentInjector;
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authSvc.canActivate(route, state)
            .flatMap(active => {
                if (active) {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }

                    const params: any = route.params;
                    const queryParams: any = route.queryParams;
                    const commonErrorData: ITCITenantNotAvailableParams = lodash.assign({}, params, queryParams);

                    // Evaluate the existing params
                    if (lodash.isEmpty(params) && lodash.isEmpty(queryParams)) {
                        console.warn("Route Activator: No params nor Tenant type present");
                        return Observable.of(false);
                    }

                    const requiredTenant = queryParams[QUERY_PARAMS.APP_TYPE];
                    let type: TCITenantAppType;
                    if (!requiredTenant) { // If no tenant is specified
                        console.warn("Route Activator: No tenant type defined on the route");
                        return Observable.of(false);
                    } else {
                        type = TCITenantAppType.fromString(requiredTenant);
                        if (!type) { // If the tenant does not exist
                            console.warn("Route Activator: No match found for given tenant");
                            return Observable.of(false);
                        }
                    }

                    const requiredComponent = params["routeid"];
                    if (requiredComponent !== QUERY_PARAMS.DEFAULT_ROUTE) { // Skip component verification if it's "default" constant
                        commonErrorData[QUERY_PARAMS.COMPONENT] = requiredComponent;

                        const inputId = params["inputid"];
                        const routeOption = this.routeResolver && this.routeResolver(requiredComponent);

                        return this.inputResolver(inputId, requiredTenant, routeOption)
                            .catch(err => {
                                console.error("App is not available", err);
                                return Observable.of(null);
                            })
                            .flatMap(inputOption => this.tenantMenuSrv.getAppDetailMenuItems(type, null, inputOption))
                            .map((comps: TCITenantAppDetailsMenu[]) => !!comps.find(comp => comp.getRouteId() === requiredComponent));
                    } else {
                        return Observable.of(true);
                    }
                } else {
                    return Observable.of(false);
                }
            });
    }

    /**
     * Route check for /routesubject/:routeid/:inputid
     * @param route
     * @param state
     */
    old_canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const _thisObj = this;
        const routeSnapshotObs = Observable.of(route).map(routeInfo => {
            while (routeInfo.firstChild) {
                routeInfo = routeInfo.firstChild;
            }
            return routeInfo;
        }).filter(routeInfo => routeInfo.outlet === "primary");

        return this.tenantCacheService.onInit()
            .flatMap(() => this.onInit())
            .flatMap(() => routeSnapshotObs)
            .flatMap(routeSnapshot => {
                const params: any = routeSnapshot.params;
                const queryParams: any = routeSnapshot.queryParams;

                const routeId = params["routeid"];
                const inputId = params["inputid"];

                if (this.checkForParams && lodash.isEmpty(inputId)) {
                    console.warn(`Parameter "inputid" is not present`);
                    return Observable.of(false);
                }

                if (this.checkForParams && routeId === QUERY_PARAMS.DEFAULT_ROUTE) { // Skip component verification if it's "default" constant
                    return Observable.of(true);
                }

                const appTypeParam: string = queryParams[QUERY_PARAMS.APP_TYPE];
                if (this.checkForParams && !appTypeParam) {
                    throw new Error(`Query Param:${QUERY_PARAMS.APP_TYPE} not found in the route`);
                }
                const routeOption = _thisObj.routeResolver && _thisObj.routeResolver(routeId);
                return _thisObj.inputResolver(inputId, appTypeParam, routeOption)
                    .catch(err => {
                        console.error("App is not available", err);
                        return Observable.of(null);
                    })
                    .flatMap(inputOption => {
                        if (inputOption === null) {
                            this.router.navigate([BASE_CONSTANTS.PAGE_NOT_FOUND], { queryParams: lodash.assign({}, params, queryParams) });
                            return Observable.of(false);
                        }

                        if (!routeOption || !inputOption.tenantAppType) {
                            console.warn("TenantAppType component request not available");
                            this.router.navigate([BASE_CONSTANTS.TENANTS_NOT_AVAILABLE], { queryParams: lodash.assign({}, params, queryParams) });
                            return Observable.of(false);
                        }

                        const requests: Observable<ICacheResponse>[] = [
                            ...routeOption.getTenantTypes()
                                .filter(tenantType => {
                                    if (this.checkForParams) {
                                        return tenantType.toString() === appTypeParam;
                                    } else {
                                        return true;
                                    }
                                })
                                .map(tenantType => _thisObj.tenantCacheService.getComponent(tenantType, routeOption.getComponentSelectorType())
                                    .map(resFactory => ({ tenantType, resFactory }))
                                    .filter(data => !lodash.isUndefined(data.resFactory) && !lodash.isEmpty(data.resFactory))
                                )
                        ];

                        return Observable.create(obs => {
                            Observable.concat(...requests)
                                .map(data => {
                                    if (inputOption &&
                                        inputOption.tenantAppType.equals(data.resFactory.tenantType) &&
                                        data.resFactory.cmpFactory.componentType.prototype instanceof AbstractTCITenantComponent &&
                                        data.resFactory.cmpFactory.componentType.prototype.getAnnotations() &&
                                        data.resFactory.cmpFactory.componentType.prototype.getAnnotations().canLoadComponent) {
                                        const modInjector = (<NgModuleRef<any>>data.resFactory.ngModFactory.create(_thisObj.getInjector())).injector;
                                        try {
                                            const bres = data.resFactory.cmpFactory.componentType.prototype.getAnnotations()
                                                .canLoadComponent(routeOption, inputOption, modInjector);
                                            const boolobs = typeof bres === "boolean"
                                                ? Observable.of(<boolean>bres)
                                                : <Observable<boolean>>bres;
                                            return Observable.create(obs1 => {
                                                boolobs.subscribe(bresult => {
                                                    if (bresult) {
                                                        obs1.next(data);
                                                        obs1.complete();
                                                    } else {
                                                        obs1.next(null);
                                                        obs1.complete();
                                                    }
                                                });
                                            });
                                        } catch (e) {
                                            console.log("canLoadComponent() failed for tenant type:" + data.tenantType.toString());
                                            console.log(e);
                                            return Observable.of(null);
                                        }
                                    } else {
                                        return Observable.of(data);
                                    }
                                })
                                .flatMap(res => res)
                                .toArray()
                                .map(res => res.filter(r => r !== null))
                                .subscribe(
                                    res => {
                                        if (res && res.length > 0) {
                                            obs.next(true);
                                            obs.complete();
                                        } else {
                                            obs.next(false);
                                            obs.complete();
                                        }
                                    },
                                    err => console.error("RouteActivator error", err)
                                );
                        });
                    });
            });
    }

    /**
     * Route check for /routesubject/:routeid/:inputid
     * @param route
     * @param state
     */
    // canActivateOld(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    //     const _thisObj = this;
    //     const routeId = route.params["routeid"];
    //     const inputId = route.params["inputid"];
    //     const appTypeParam: string = route.queryParams[QUERY_PARAMS.APP_TYPE];
    //     if (!appTypeParam) {
    //         throw new Error(`Query Param:${QUERY_PARAMS.APP_TYPE} not found in the route`);
    //     }
    //     const routeOption = _thisObj.routeResolver && _thisObj.routeResolver(routeId);
    //     // const inputOption: I = _thisObj.inputResolver && <I>_thisObj.inputResolver(inputId, appTypeParam);
    //     const inputOption = null;
    //     const tenantServices = this
    //         .tenantRemoteServices
    //         .getRemoteServices()
    //         .flatMap(svc => svc)
    //         .filter((tenant: IService) => {
    //             const cfg = (<any>SystemJS).getConfig();
    //             const appType = TCITenantAppType.fromString(tenant.name);
    //             const svcName = appType.getSvcName();
    //             return cfg.map && cfg.packages && cfg.map[svcName] &&
    //                 routeOption && appType.appliesTo(routeOption.getTenantTypes());
    //         });
    //
    //     const tenObs = tenantServices.map((tenant: IService) =>
    //         Observable.fromPromise(this.loader.load(TCITenantAppType.fromString(tenant.name).getSvcName()))
    //     )
    //         .flatMap(modFac => modFac)
    //         .map(modFactory => {
    //             return Observable.fromPromise(_thisObj.compiler.compileModuleAndAllComponentsAsync<any>(modFactory.moduleType));
    //         })
    //         .flatMap(obsfactory => obsfactory)
    //         // add ngModFatory with cmpFactory
    //         .switchMap(mwcfactories => Observable.of(...mwcfactories.componentFactories), (ngModFactory, cmpFactory) => ({
    //             ngModFactory,
    //             cmpFactory
    //         }))
    //         // add route option
    //         .switchMap(fac => Observable.of(routeOption), (fac, menuItem, x, y) => {
    //             const canLoadComponent = false;
    //             const cmpFactory = fac.cmpFactory;
    //             const modInjector = (<NgModuleRef<any>>fac.ngModFactory.ngModuleFactory.create(_thisObj.getInjector())).injector;
    //             return (
    //                 { cmpFactory, modInjector, menuItem, canLoadComponent }
    //             );
    //         }
    //         )
    //         // Selector match
    //         .filter(data =>
    //             data.cmpFactory.componentType.prototype instanceof AbstractTCITenantComponent
    //             && data.cmpFactory.componentType.prototype.getAnnotations()
    //             && data.cmpFactory.selector === data.menuItem.getComponentSelectorType().toString()
    //         )
    //         // distinct component
    //         .distinct(data => {
    //             if (
    //                 routeOption.getComponentSelectorType()
    //                     .isEqualTo(data.cmpFactory.selector) &&
    //                 data.cmpFactory.componentType.prototype instanceof AbstractTCITenantComponent &&
    //                 data.cmpFactory
    //                     .componentType
    //                     .prototype
    //                     .getAnnotations() &&
    //                 data.cmpFactory
    //                     .componentType
    //                     .prototype
    //                     .getAnnotations()
    //                     .distinctionKeyFn
    //             ) {
    //                 return data.cmpFactory
    //                     .componentType
    //                     .prototype
    //                     .getAnnotations()
    //                     .distinctionKeyFn(inputOption);
    //             } else {
    //                 return data;
    //             }
    //         })
    //         // Loadable based on canLoadComponent
    //         .map(data => {
    //             if (inputOption &&
    //                 data.cmpFactory.componentType.prototype instanceof AbstractTCITenantComponent &&
    //                 data.cmpFactory.componentType.prototype.getAnnotations() &&
    //                 data.cmpFactory.componentType.prototype.getAnnotations().canLoadComponent) {
    //                 const bres = data.cmpFactory.componentType.prototype.getAnnotations().canLoadComponent(data.menuItem, inputOption, data.modInjector);
    //                 const boolobs = typeof bres === "boolean"
    //                     ? Observable.of(<boolean>bres)
    //                     : <Observable<boolean>>bres;
    //                 return <Observable<{ cmpFactory: ComponentFactory<any>, menuItem: ITCITenantComponentOptions<any>, canLoadComponent: boolean }>>
    //                     Observable.create(obs => {
    //                         boolobs.subscribe(bresult => {
    //                             data.canLoadComponent = bresult;
    //                             obs.next(data);
    //                             obs.complete();
    //                         });
    //                     });
    //
    //             } else {
    //                 data.canLoadComponent = true;
    //                 return Observable.of(data);
    //             }
    //         })
    //         .flatMap(data => data)
    //         .map(data => data.canLoadComponent);
    //
    //     return this.onInit()
    //         .map(res => {
    //             return <Observable<Observable<boolean>>>Observable.create(observer => {
    //                 // check if there are any matching services otherwise return false
    //                 tenantServices
    //                     .toArray()
    //                     .subscribe(
    //                         (tres) => {
    //                             if (tres && tres.length > 0) {
    //                                 observer.next(tenObs);
    //                                 observer.complete();
    //                             } else {
    //                                 observer.next(Observable.of(false));
    //                                 observer.complete();
    //                             }
    //                         }
    //                     );
    //             });
    //         })
    //         .flatMap(res => res)
    //         .flatMap(res => res);
    // }
}
